module.exports = __webpack_public_path__ + "img/leaf.8e52668.svg";